import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { BorderRadius, Colors, Fonts, ShadowValue, Spacing } from "@snapchat/snap-design-system";

export const Content = styled.div`
    display: flex;
    width: 100%;
`;

export const Box = styled.div`
    width: 75vw;
    padding: ${Spacing.LG}px;

    text-align: center;

    background-color: ${Colors.WHITE};
    border-radius: ${BorderRadius.container}px;
    box-shadow: ${ShadowValue.regular};
`;

export const ErrorImage = styled.img`
    width: 125px;
`;

export const ErrorText = styled.div`
    ${Fonts.Heading.H500};
    margin-top: ${Spacing.MD}px;
`;

export const ButtonWrapper = styled.div`
    margin-top: ${Spacing.MD}px;
`;

export const actionButtonStyle = css`
    margin: 0 ${Spacing.XS}px;
`;
